// extracted by mini-css-extract-plugin
var _1 = "header-icon__7_TtM";
var _2 = "markdown__wW7Z2";
var _3 = "terms-box__Eb5hs";
export { _1 as "headerIcon", _2 as "markdown", _3 as "termsBox" }
